<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="5" md="6" sm="8" xs="12">
        <EntryExp></EntryExp>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import EntryExp from "@/components/ExpEntry";
export default {
  components: { EntryExp },
};
</script>
